export { default } from './use-interval';
